
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({})
export default class MatchStatus extends Vue {
  name: 'MatchStatus';
  @Prop() matchdata: MatchInterface;
  get matchStatus(): string {
    if(this.matchdata.liveData && this.matchdata.liveData.matchDetails && this.matchdata.liveData.matchDetails.matchStatus){
      return this.matchdata.liveData.matchDetails.matchStatus;
    }
    return "Fixture";
  }

  get status() {
    let status = this.matchStatus;
    if(status === "Fixture"){
      let dateTime = new Date(`${this.matchdata.matchInfo.date.replace('Z','')}T${this.matchdata.matchInfo.time}`);
      return new Intl.DateTimeFormat('en-SG', {hour: 'numeric', minute: 'numeric'}).format(dateTime);
    }

    if(status === "Played"){
      if(typeof(this.matchdata.liveData.matchDetails.scores) !== 'undefined' ){
        if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
          return "FT(P)";
        }
        return "FT";
      }
      return "";
    }

    if(status === "Playing"){
      // If there is "Penalties"
      if(typeof(this.matchdata.liveData.matchDetails.scores) !== 'undefined' ){
        if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
          return "Penalties";
        }
      }
      
      // Extra Time
      if(this.matchdata.liveData && this.matchdata.liveData.matchDetails){
        if(this.matchdata.liveData.matchDetails.matchTime && this.matchdata.liveData.matchDetails.matchTime > 0){
          if(this.matchdata.liveData.matchDetails.matchTime > 90){
            let ot = this.matchdata.liveData.matchDetails.matchTime - 90;
            return `90m +  ${ot}m`;
          }
          if(this.matchdata.liveData.matchDetails.matchTime > 45 && this.matchdata.liveData.matchDetails.periodId == 1){
            let ot = this.matchdata.liveData.matchDetails.matchTime - 45;
            return `45m +  ${ot}m`;
          }
          return `${this.matchdata.liveData.matchDetails.matchTime}m`;
        }else if(typeof(this.matchdata.liveData.matchDetails.matchTime) == 'undefined' && this.matchdata.liveData.matchDetails.periodId == 10) {
          return "Half Time";
        }

        return "0m";
      } 
      
      return "0m";
    }

    if(status === "Cancelled"){
      //TODO: Do something
      return "Cancelled";
    }

    if(status === "Postponed"){
      if(this.matchdata.matchInfo && this.matchdata.matchInfo.date && this.matchdata.matchInfo.date !== "" ) {
         let dateTime = new Date(`${this.matchdata.matchInfo.date.replace('Z','')}T${this.matchdata.matchInfo.time}`);
        return new Intl.DateTimeFormat('en-SG', {hour: 'numeric', minute: 'numeric'}).format(dateTime);
      }  
      //TODO: Do something
      return "";
    }

    if(status === "Suspended"){
      //TODO: Do something
      return "Suspended";
    }

    if(status === "Awarded"){
      //TODO: Do something
      return "Awarded";
    }

    if(status === "Abandoned"){
      //TODO: Do something
      return "";
    }

    return "";
  }
}
